import type { NormalizedRoundSchedule, RoundName } from "../../domain/round/types";
import type { TransportPlan } from "../../domain/transport/types";
import type { RoundWorkspacePayload } from "../../lib/api";

async function errorMessage(response: Response) {
  const body = await response.json().catch(() => null);
  const detail = body && typeof body === "object" && "detail" in body ? (body as { detail?: unknown }).detail : null;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && "message" in detail) return String((detail as { message?: unknown }).message || "");
  return `HTTP ${response.status}`;
}

export async function resolveManualConflict(
  tournamentId: string,
  round: RoundName,
  payload: {
    baseRevision: number;
    schedule: NormalizedRoundSchedule;
    transport: TransportPlan | null;
    transportStale: boolean;
  },
) {
  const response = await fetch(`/api/tournaments/${encodeURIComponent(tournamentId)}/rounds/${round}/workspace/resolve-conflict`, {
    method: "POST",
    credentials: "include",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(await errorMessage(response));
  return response.json() as Promise<RoundWorkspacePayload & { conflictResolution?: { baseRevision: number; replacedServerRevision: number; savedRevision: number; resolvedBy: string } }>;
}
